var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 93.2 52",
    style: {
      enableBackground: "new 0 0 93.2 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -12.6284,
    y1: 783.5732,
    x2: 146.3273,
    y2: 860.7089,
    gradientTransform: "matrix(1 0 0 1 0 -787.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1248,
    style: {
      stopColor: "#2181F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0C417B"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.2,33.5l12.6-14.9H64.6v-4.7h20v3.9L72.1,32.7H85v4.7H64.2V33.5z M49.9,33.2c2.2,0,4.1-0.7,5.5-2.2 c1.4-1.4,2.2-3.3,2.2-5.5s-0.7-4.1-2.2-5.5c-1.4-1.4-3.3-2.1-5.5-2.1c-1.8,0-3.4,0.5-4.7,1.4c-1.4,1-2.3,2.2-2.9,3.8v4.7 c0.5,1.6,1.5,2.9,2.9,3.9C46.6,32.8,48.2,33.2,49.9,33.2z M36.1,13.9h6v2.8c1.3-1.2,2.6-2.1,4.2-2.7c1.5-0.6,3.2-0.9,5.1-0.9 c2.4,0,4.6,0.5,6.4,1.6c1.9,1,3.4,2.5,4.4,4.3c1.1,1.8,1.6,4,1.6,6.5c0,2.4-0.6,4.6-1.6,6.5c-1.1,1.8-2.6,3.4-4.4,4.4 c-1.9,1-4,1.6-6.4,1.6c-1.8,0-3.5-0.2-5.1-0.7s-2.9-1.3-4-2.3v13h-6.2V13.9z M25.4,13.9h6.3v23.5h-6.3 C25.4,37.4,25.4,13.9,25.4,13.9z M28.6,9.8c-1,0-1.8-0.3-2.5-1c-0.6-0.6-1-1.4-1-2.4s0.3-1.8,1-2.4c0.8-0.7,1.6-1,2.5-1 c1,0,1.8,0.3,2.5,1c0.7,0.6,1,1.4,1,2.4s-0.3,1.8-1,2.4C30.5,9.5,29.6,9.8,28.6,9.8z M17.5,38.1c-2.6,0-4.6-0.7-5.9-2.2 c-1.3-1.4-2-3.5-2-6V18.6H5.9v-4.7h3.6V6.8h6.2v7h5.7v4.7h-5.7V29c0,1.5,0.2,2.6,0.8,3.2c0.6,0.6,1.6,0.9,3,0.9c1,0,2-0.2,3-0.7 v4.7C21.2,37.9,19.5,38.1,17.5,38.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNew);
export default __webpack_public_path__ + "static/media/logo-new.26e4e40b80553a23e9976de78f8c5901.svg";
export { ForwardRef as ReactComponent };